<template src="./AnnouncementClose.html"></template>

<script>
export default {
  name: "announcement-close",
  props: {
    name: { type: String },
    dateInit: { type: String },
    dateFinish: { type: String },
    description: { type: String },
    image: { type: String },
    descriptionImg: {
      type: String,
      default: "Imagen de la convocatoria cerrada",
    },
    buttonText: { type: String },
    ratingQualification: { type: Number },
  },
  methods: {
    pushButton() {
      this.$emit("announcementCloseButton");
    },
  },
  computed: {
    imgUrl() {
      return this.image
        ? this.image
        : "https://storage.googleapis.com/arroba-downloads/recursos/Img_default.png";
    },
  },
};
</script>

<style lang="scss" scoped src="./AnnouncementClose.scss"></style>
